import { useAuth } from 'src/contexts';
import { SCHOOLCODE_USERGUIDE_NAME , SCORESENDCODE_USERGUIDE_NAME} from 'src/constants';


export const openAndDownloadPDF = (pdfFileName: string) => {

  // Define the path to the PDF file in the public folder using the conditional file name
  const  pdfFilePath = `/userguide/${pdfFileName}.pdf`;
  try {
    //open the user guide in a new tab
    window.open(pdfFilePath, '_blank',"noopener,noreferrer");

    //Trigger the download of the user guide
    const link = document.createElement('a');
    link.href = pdfFilePath;
    link.setAttribute('download', pdfFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  catch (error) {
    console.error('Error opening and downloading the PDF file:', error);
  }

}